import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/auth";
import { client as supabase } from "./utils/supabase";
import { SessionContextProvider } from "@supabase/auth-helpers-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "./styles/tipografia.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <SessionContextProvider supabaseClient={supabase}>
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <App />
          <Toaster position="bottom-right" reverseOrder={false} />
        </AuthProvider>
      </Router>
    </HelmetProvider>
  </SessionContextProvider>
);
